import styled from 'styled-components';

export const PopupEditButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  margin: 15px;
`;
